export default __webpack_public_path__ + "static/media/2 - Мероприятия по высадке деревьев.412eb334.jpg";